import {
  Component,
  OnDestroy,
  ViewChild,
  inject} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { filter, map, Subscription, switchMap } from 'rxjs';

import { SidenavKey, SidenavService } from '../../services/sidenav-service';
import { ProjectService } from 'src/app/services/project.service';
import {Group, Member} from 'src/app/models/project';
import { TranslationHelperService } from 'src/app/services/translations/translation-helper.service';
import { OLMapService } from 'src/app/services/ol-map/ol-map.service';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnDestroy {
  private readonly router = inject(Router);
  private readonly subscriptions = new Subscription();

  protected readonly sidenavService = inject(SidenavService);
  protected readonly projectService = inject(ProjectService);
  protected readonly translationHelper = inject(TranslationHelperService);
  private readonly olMapService = inject(OLMapService);

  readonly icons = {
    times: faTimes,
    bars: faBars
  };

  sidenavOpen: boolean = false;
  members: Member[] = [];
  route = '';
  lang = '';

  @ViewChild('sidenav')
  sidenav?: MatSidenav;

  constructor() {
    this.subscriptions.add(
      this.sidenavService
        .watch(SidenavKey.MAIN)
        .subscribe(open => {
          this.sidenavOpen = open;
        })
    );

    this.members = this.projectService.groups.reduce(
      (members: Member[], group: Group) => members.concat(group.members),
      []
    );

    this.subscriptions.add(
      this.router.events
        .pipe(
          filter(
            (event): event is NavigationEnd =>
              event instanceof NavigationEnd
          ),
          switchMap(event =>
            this.translationHelper.getLanguage().pipe(
              map(lang => ({
                lang,
                route: event.urlAfterRedirects.split('?')[0]
              }))
            )
          )
        )
        .subscribe(({ lang, route }) => {
          this.lang = lang ?? '';
          this.route = route;
        })
    );
  }

  resetMap(): void {
    this.olMapService.reset();
  }

  onMemberClick(member: Member): void {
    if (!this.checkMember(member)) {
      this.resetMap();
    }
    this.toggleMenu();
  }

  toggleMenu(): void {
    this.sidenavService.toggle(SidenavKey.MAIN);
  }

  checkMember(member: Member): boolean {
    return `/${this.lang}/${member.routerLink}` === this.route;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}


